import { SpaceBetween } from '@amzn/awsui-components-core';
import React from 'react';
import {
  renderCancelCreateModalButton,
  renderConfirmCreateModalButton,
} from './APGLUserProfileUtils';

interface Props {
  isCreatingProfile: boolean;
  handleConfirm: () => Promise<void>;
  handleCancel: () => void;
}

const APGLUserProfileCreateControls: React.FunctionComponent<Props> = ({
  isCreatingProfile,
  handleConfirm,
  handleCancel,
}: Props) => {
  const cancelButton = renderCancelCreateModalButton('link', handleCancel);
  const confirmButton = renderConfirmCreateModalButton(handleConfirm, isCreatingProfile);
  return (
    <SpaceBetween direction="horizontal" size="s">
      {cancelButton}
      {confirmButton}
    </SpaceBetween>
  );
};

export default APGLUserProfileCreateControls;
